/*       */

import { gql } from '@apollo/client';

export default gql`
    query tasksAutocompleteQuery($page: Int, $pageSize: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        result: tasks(page: $page, itemsPerPage: $pageSize, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            type
        }
    }
`;
